'use client';

interface SubmissionErrorMessageProps {
  message?: string | null;
}

export const SubmissionErrorMessage = ({
  message,
}: SubmissionErrorMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <p
      aria-live="polite"
      className="mt-4 text-center text-sm leading-5 font-semibold text-nimbus-destructive"
      role="alert"
    >
      {message}
    </p>
  );
};
